var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"slideDown"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$store.getters.getLoadingState),expression:"this.$store.getters.getLoadingState"}],staticClass:"splash-screen"},[_c('div',{staticClass:"loader"},[_c('img',{staticClass:"logo-splash",attrs:{"src":_vm.logo}})])])]),_vm._v(" "),_c('app-nav'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-551510b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 322
// module chunks = 9